export function initNav() {
    const openBtn = document.getElementById('mobileNavOpen');
    const closeBtn = document.getElementById('mobileNavClose');
    const panel = document.getElementById('mobileNavPanel');

    if (openBtn && panel) {
        openBtn.addEventListener('click', function () {
            panel.classList.remove('translate-x-full');
            panel.classList.add('is-open');
            document.body.classList.add('overflow-hidden');
            openBtn.setAttribute('aria-expanded', 'true');
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                panel.classList.add('translate-x-full');
                panel.classList.remove('is-open');
                document.body.classList.remove('overflow-hidden');
                openBtn.setAttribute('aria-expanded', 'false');
            });
        }
    }

    const navItems = document.querySelectorAll('[data-nav-item]');
    const isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function openDropdown(li) {
        const link = li.querySelector(':scope > a');
        const dropdown = li.querySelector('[data-nav-dropdown]');
        const chevron = li.querySelector(':scope > a svg');
        if (dropdown) {
            dropdown.classList.remove('opacity-0', 'invisible', 'translate-y-2', 'pointer-events-none');
            dropdown.classList.add('opacity-100', 'visible', 'translate-y-0', 'pointer-events-auto');
            dropdown.setAttribute('aria-hidden', 'false');
        }
        if (link) {
            link.setAttribute('aria-expanded', 'true');
        }
        if (chevron) {
            chevron.classList.add('rotate-180');
        }
    }

    function closeDropdown(li) {
        const link = li.querySelector(':scope > a');
        const dropdown = li.querySelector('[data-nav-dropdown]');
        const chevron = li.querySelector(':scope > a svg');
        if (dropdown) {
            dropdown.classList.add('opacity-0', 'invisible', 'translate-y-2', 'pointer-events-none');
            dropdown.classList.remove('opacity-100', 'visible', 'translate-y-0', 'pointer-events-auto');
            dropdown.setAttribute('aria-hidden', 'true');
        }
        if (link) {
            link.setAttribute('aria-expanded', 'false');
        }
        if (chevron) {
            chevron.classList.remove('rotate-180');
        }
    }

    function closeAllDropdowns() {
        navItems.forEach(function (li) {
            li.classList.remove('touch-open');
            closeDropdown(li);
        });
    }

    if (isHoverDevice) {
        navItems.forEach(function (li) {
            li.addEventListener('mouseenter', function () {
                closeAllDropdowns();
                openDropdown(li);
            });
            li.addEventListener('mouseleave', function () {
                closeDropdown(li);
            });
        });
    } else {
        navItems.forEach(function (li) {
            const link = li.querySelector(':scope > a');
            if (!link) return;
            link.addEventListener('click', function (e) {
                const isOpen = li.classList.contains('touch-open');
                if (!isOpen) {
                    e.preventDefault();
                    closeAllDropdowns();
                    li.classList.add('touch-open');
                    openDropdown(li);
                } else {
                    li.classList.remove('touch-open');
                    closeDropdown(li);
                }
            });
        });

        document.addEventListener('click', function (e) {
            if (!e.target.closest('[data-nav-item]')) {
                closeAllDropdowns();
            }
        });
    }

    // Hide nav on scroll down, reveal on scroll up
    const scrollNav = document.querySelector('[data-scrollnav]');
    const header = scrollNav && scrollNav.closest('header');
    if (scrollNav && header) {
        let navIsHidden = false;
        // Remove overflow-hidden after the reveal animation so dropdowns are never clipped
        scrollNav.addEventListener('transitionend', function () {
            if (!navIsHidden) {
                scrollNav.classList.remove('overflow-hidden');
            }
        });

        window.addEventListener('scroll', function () {
            const mobileIsOpen = panel && panel.classList.contains('is-open');
            if (mobileIsOpen) return;

            if (window.scrollY > 0) {
                scrollNav.classList.add('overflow-hidden');
                header.classList.add('header-scrolled');
            } else {
                header.classList.remove('header-scrolled');
            }
        }, { passive: true });
    }
}
